import { createActions, createReducer } from 'reduxsauce'

import ConsultaPagamentoContraChequeService from '../../servicos/ConsultaPagamentoContraChequeService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaPagamentoContraChequeInicio: [],
    buscaConsultaPagamentoContraChequeErro: ['erro'],
    buscaConsultaPagamentoContraChequeSucesso: ['consultaPagamentoContraCheque'],
    limpar: [],
    setConsultaPagamentoContraChequeEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaPagamentoContraCheque = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaPagamentoContraChequeInicio())
        let serv = new ConsultaPagamentoContraChequeService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaPagamentoContraChequeSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaPagamentoContraChequeErro(error)))
    }
}

const buscaConsultaPagamentoContraChequeInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaPagamentoContraChequeErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaPagamentoContraChequeSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaPagamentoContraCheque.resultado,
        dataSincronizacaoDados: action.consultaPagamentoContraCheque.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaPagamentoContraCheque.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaPagamentoContraChequeEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PAGAMENTO_CONTRA_CHEQUE_INICIO]: buscaConsultaPagamentoContraChequeInicio,
    [Types.BUSCA_CONSULTA_PAGAMENTO_CONTRA_CHEQUE_ERRO]: buscaConsultaPagamentoContraChequeErro,
    [Types.BUSCA_CONSULTA_PAGAMENTO_CONTRA_CHEQUE_SUCESSO]: buscaConsultaPagamentoContraChequeSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PAGAMENTO_CONTRA_CHEQUE_ESTADO_DT]: setConsultaPagamentoContraChequeEstadoDT,
})
